import { AtMentionsViewState } from '../store/schema/AtMentionsViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('removeMentionTuple')(function removeMentionTuple(
    viewState: AtMentionsViewState,
    nodeId: string
) {
    delete viewState.atMentionTuples[nodeId];
});
